import {
  Button,
  Card,
  Container,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import wolf from "../assets/wolf.png";

export const ContactComponent = ({ navigatelink, btnLabel, titleLable }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Container data-aos="fade-up" data-aos-duration="1000">
      <Grid
        container
        spacing={0.5}
        borderRadius={5}
        // sx={{ bgcolor: theme.palette.mode === "light" ? "#d6d9f7" : "#180c47" }}
        sx={{ bgcolor: theme.palette.mode === "light" ? "#d6d9f7" : "#180c47" }}
      >
        <Grid
          item
          sx={{
            display: "flex",
          }}
          xs={12}
          sm={6}
        >
          <Card
            variant=""
            sx={{
              p: 1,
              height: "fit-content",
              background: "none",
              border: "none",
              textAlign: "center",
            }}
          >
            <Typography color="text.primary" variant="body2" fontWeight="bold">
              <img src={wolf} width="85%" alt="code1" />
            </Typography>
          </Card>
        </Grid>
        <Grid item sx={{ display: "flex" }} xs={12} sm={6}>
          <Card
            variant=""
            sx={{
              p: 3,
              background: "none",
              border: "none",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <Typography
              component="h2"
              variant="h5"
              color="text.primary"
              fontWeight="bold"
              sx={{
                lineHeight: { xs: "1.5rem" },
                mt: 2,
                mb: 5,
                textAlign: "center",
              }}
            >
              {titleLable}
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ textAlign: "center" }}
            >
              <Button
                variant="contained"
                size="large"
                color="secondary"
                sx={{
                  p: 1.5,
                  width: "250px",
                  fontWeight: "bold",
                  fontSize: 17,
                }}
                onClick={() => {
                  navigatelink === "/book-a-call"
                    ? window.open("/book-a-call", "_blank")
                    : navigate(navigatelink);
                }}
              >
                {btnLabel}
              </Button>
            </Typography>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};
